import * as React from 'react';

import type { IconProps } from '../types';

const StatusDot = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M8.00002 3.74023C10.3525 3.74027 12.26 5.64778 12.26 8.00023C12.26 10.3527 10.3525 12.2602 8.00002 12.2602C5.64749 12.2602 3.74002 10.3528 3.74002 8.00023C3.74009 5.64776 5.64753 3.74023 8.00002 3.74023Z"
        />
      </svg>
    );
  }
);

StatusDot.displayName = 'StatusDot';

export { StatusDot };
